export * from "@/ui/components/typography/TextSubtitle/TextSubtitle";
export * from "@/ui/components/typography/TextSubtitle/TextSubtitle.config";
